import { render, staticRenderFns } from "./EmergencyKeywordsCard.vue?vue&type=template&id=f4e66706&"
import script from "./EmergencyKeywordsCard.vue?vue&type=script&lang=js&"
export * from "./EmergencyKeywordsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4e66706')) {
      api.createRecord('f4e66706', component.options)
    } else {
      api.reload('f4e66706', component.options)
    }
    module.hot.accept("./EmergencyKeywordsCard.vue?vue&type=template&id=f4e66706&", function () {
      api.rerender('f4e66706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/EmergencyKeywordsCard.vue"
export default component.exports